module.exports = __webpack_public_path__ + "img/logo-lentu.f87d6656.jpg";